angular.module('impactx.rfxsupplier').controller('RFXSupplierEditCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    'ToastService',
    '$routeParams',
    '$mdDialog',
    '$redirect',
    'DownloadService',
    'ConfirmationService',
    'ProductSelectionService',
    'AppConfiguration',
    '$copyToClipboard',
    'ToolbarService',
    '$timeout',
    'RFXSupplierService',
    'RedirectAndSaveService',
    'LoadingDialogService',
    '$route',
    '$securityManager',
    'RFQSearchService',
    '$location',
    '$errorHandler',
    RFXSupplierEditController
]);

function RFXSupplierEditController($scope, dataGen, TranslationService, ToastService, $routeParams,
                                   $mdDialog, $redirect, DownloadService, ConfirmationService, ProductSelectionService,
                                   AppConfiguration, $copyToClipboard, ToolbarService, $timeout, RFXSupplierService,
                                   RedirectAndSaveService, LoadingDialogService, $route, $securityManager, RFQSearchService,
                                   $location, $errorHandler) {
    var self = this;
    self.requestInProgress = false;
    $scope.showItemComments = {value: false};
    $scope.selectedItems = [];
    $scope.selectedContracts = [];
    $scope.selectedConditions = [];
    $scope.hasChanged = false;
    $scope.locationWatcher = $scope.$on('$locationChangeStart', function (event) {
        saveRequest(false, true);
    });
    var sendErrorList = {list: []};

    var commentErrorList = {list: []};

    self.suppressWarnings = false;

    var getData = function () {
        var data = RFQSearchService.getDialogData();

        if ($routeParams.productIdToAdd < 0 && data && data.data) {
            $scope.data = data.data;
            $scope.trns = data.trns;
            $scope.setButtons();
        }
        else if ($routeParams.productIdToAdd > 0 && data && data.data) {
            $scope.data = data.data;
            $scope.trns = data.trns;
            dataGen.getData({}, {
                rfqsId: $scope.data.id,
                proId: $routeParams.productIdToAdd,
                cscId: $routeParams.cscIdForProductToAdd ? $routeParams.cscIdForProductToAdd : 0,
                amount: decodeURIComponent($routeParams.amountToAdd)
            }, "/rfx/supplier/newsupplieritem").then(function (data) {
                $scope.setButtons();
                if (data && data.data) {
                    var item = data.data;
                    item.isEdited = true;
                    var cscId = impactX.isDefined(item, 'csc.id');
                    var lotId = impactX.isDefined(item, 'lot.id');
                    if (cscId || lotId) {
                        RFXSupplierService.addItemToContracts(item, null, null, $scope.data, false, $scope.dialogData, sendErrorList);
                    }
                    else {
                        RFXSupplierService.showContractOrLotSelectionDialog(event, item, $scope.data.id, $scope.trns).then(function (contractData) {
                            angular.extend(item, contractData);
                            RFXSupplierService.addItemToContracts(item, null, null, $scope.data, false, $scope.dialogData, sendErrorList);
                        });
                    }
                }
                LoadingDialogService.stop()
            }, function () {
                LoadingDialogService.stop();
                $scope.setButtons();
            });
        }
        else {
            LoadingDialogService.start();
            dataGen.getData($scope, {id: $routeParams.id}, "/rfx/supplier/view").then(function () {
                $scope.setButtons();
                $scope.adjustDates();
                $scope.checkComments();
                RFXSupplierService.updateSupplierHeaderSum(true, $scope.data, $scope.dialogData, sendErrorList);
                if ($scope.data.useTerms && !$scope.data.hasOfferCreated) {
                    RFXSupplierService.showTermsDialog(null, $scope.data.id, $scope.data.termsText, $scope.data.termsAttachments, $scope.trns);
                }
                LoadingDialogService.stop();
            }, LoadingDialogService.stop);
        }
    };

    $scope.save = function () {
        return saveRequest(false);
    };

    $scope.saveAndBack = function () {
        return saveRequest(true);
    };

    $scope.checkComments = function () {
        if ($scope.data.useSimpleSupplierRecommendation) {
            if ($scope.data.supplierHeaderComments.mixedComments.comments.length > 0) {
                commentErrorList = {list: []};
            }
            else {
                commentErrorList.list.push($scope.trns.missingCommentsForSimpleSupplierRecommendation);
            }
        }
    };

    $scope.back = function () {
        if ($scope.locationWatcher) {
            $scope.locationWatcher();
        }
        if ($scope.data.comparisonOffer) {
            $redirect.redirectTo(null, "/rfxbuyer/" + $routeParams.rfqhId);
        }
        else if ($securityManager.isProcessAllowed("RFXSupplierView")) {
            $redirect.redirectTo(null, "/rfxsupplierlist");
        }
        else if ($securityManager.isProcessAllowed("RFXSupplierViewForBuyer")) {
            $redirect.redirectTo(null, "/rfx/offers/" + $routeParams.rfqhId);
        }
    }

    function saveRequest(redirectBack, backGround) {
        var dataObj = {
            data: $scope.data
        };
        cacheAllItemComments();
        LoadingDialogService.start();
        return dataGen.postAsForm({}, dataObj, "/rfx/supplier/save").then(function (response) {
            if (response.data && response.data.saveAttachmentsEncrypted) {
                RFXSupplierService.saveItemCommentsEncrypted($scope.data.id);
            }
            else if (impactX.isDefined(response, "data.tokens")) {
                RFXSupplierService.saveItemComments(response.data.tokens);
            }
            LoadingDialogService.stop();

            if (!backGround) {
                if (redirectBack) {
                    $scope.back();
                }
                else {
                    $route.reload();
                }
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            }
        }, function () {
            LoadingDialogService.stop();
            if (!backGround) {
                restoreAllItemComments();
            }
        });
    }

    $scope.reworkRequest = function () {
        var dataObj = {
            data: $scope.data
        };
        LoadingDialogService.start();
        return dataGen.postAsForm({}, dataObj, "/rfx/supplier/rework").then(function () {
            var location = $location.path();
            if ($routeParams.amountToAdd) {
                location = location.substring(0, location.lastIndexOf("/"));
            }
            if ($routeParams.cscIdForProductToAdd) {
                location = location.substring(0, location.lastIndexOf("/"));
            }
            if ($routeParams.productIdToAdd) {
                location = location.substring(0, location.lastIndexOf("/"));
            }
            if (location !== $location.path()) {
                $redirect.redirectTo(null, location);
            }
            else {
                // LoadingDialogService.stop(); is called after reload
                $redirect.reload();
            }
        });
    };

    $scope.replyDialog = function (event) {
        if ($scope.data.offerConfirmationText) {
            ConfirmationService.showHTMLConfirmationDialog($scope.replyRequest, event, TranslationService.get("warning"),
                $scope.trns.replyRequest, TranslationService.get("abort"), $scope.data.offerConfirmationText);
        }
        else {
            $scope.replyRequest(event);
        }
    };

    $scope.sendSupplierRecommendationDialog = function (event) {
        if ($scope.data.offerConfirmationText) {
            ConfirmationService.showHTMLConfirmationDialog($scope.sendSupplierRecommendation, event, TranslationService.get("warning"),
                $scope.trns.sendSupplierRecommendation, TranslationService.get("abort"), $scope.data.offerConfirmationText);
        }
        else {
            $scope.sendSupplierRecommendation(event);
        }
    };

    $scope.sendSupplierRecommendation = function (event) {
        return $mdDialog.show({
            controller: 'RFXSupplierRFQHRecommendationCtrl',
            controllerAs: 'rfxSupplierRFQHRecommendationCtrl',
            templateUrl: 'modules/rfxsupplier/templates/rfqsupplierreccomendation.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            escapeToClose: false,
            bindToController: true,
            locals: {
                data: $scope.data,
                trns: $scope.trns,
                locationWatcher: $scope.locationWatcher
            }
        }).then(function (reload) {
            if (reload) {
                // refresh on failed validation since the items were versioned on save before trying to reply
                getData();
                adjustSelections();
            }
        });
    };

    $scope.directCreateRFQHAfterSave = function () {
        const redirectAfterSend = function () {
            if ($scope.locationWatcher) {
                $scope.locationWatcher();
            }
            if ($scope.data.comparisonOffer) {
                $redirect.redirectTo(null, "/rfxbuyer/" + $routeParams.rfqhId);
            }
            else if ($securityManager.isProcessAllowed("RFXSupplierView")) {
                $redirect.redirectTo(null, "/rfxsupplierlist");
            }
            else if ($securityManager.isProcessAllowed("RFXSupplierViewForBuyer")) {
                $redirect.redirectTo(null, "/rfx/offers/" + $routeParams.rfqhId);
            }
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        }

        LoadingDialogService.start();
        self.requestInProgress = true;
        dataGen.postAsForm({}, {data: $scope.data},
            "/rfx/supplier/createrfqh/direct", false, true).then(function (data) {
            self.requestInProgress = false;
            LoadingDialogService.stop();
            if (data.data.canShare && $scope.data.creator.id <= 0) {
                self.shareRFX().then(redirectAfterSend, function () {
                    $redirect.reload();
                    ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                });
            }
            else {
                redirectAfterSend();
            }
        }, function () {
            // refresh on failed validation since the items were versioned on save before trying to reply
            getData();
            adjustSelections();
        }).finally(function () {
            LoadingDialogService.stop();
            self.requestInProgress = false;
        });
    };

    $scope.directCreateRFQHDialog = function (event) {
        if ($scope.data.offerConfirmationText) {
            ConfirmationService.showHTMLConfirmationDialog($scope.directCreateRFQH, event, TranslationService.get("warning"),
                $scope.trns.createSupplierRequest, TranslationService.get("abort"), $scope.data.offerConfirmationText);
        }
        else {
            $scope.directCreateRFQH(event);
        }
    };

    $scope.directCreateRFQH = function (event, preventMinLastDateContractOrLotCheck) {
        self.requestInProgress = true;
        cacheAllItemComments();
        LoadingDialogService.start();
        dataGen.postAsForm({}, {data: $scope.data, checkLastDate: !preventMinLastDateContractOrLotCheck}, "/rfx/supplier/save").then(function (response) {
            if (response.data && response.data.minLastDateContractOrLot) {
                LoadingDialogService.stop();
                self.requestInProgress = false;
                restoreAllItemComments();
                $mdDialog.show({
                    controller: 'RFXLastValidDateConfirm',
                    controllerAs: 'rfxLastValidDateConfirm',
                    templateUrl: 'modules/rfxsupplier/templates/rfx-last-valid-date-confirm-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    bindToController: true,
                    locals: {
                        abortLabel: TranslationService.get("abort"),
                        actionLabel: $scope.trns.send,
                        warningLabel: TranslationService.get("warning"),
                        changeDateAndActionLabel: $scope.trns.changeDateAndSend,
                        minLastDateContractOrLot: response.data.minLastDateContractOrLot,
                        minLastDateContractOrLotMessage: response.data.minLastDateContractOrLotMessage
                    }
                }).then(function (answer) {
                    if (answer.changeDate) {
                        $scope.data.validDate.dateValue = response.data.minLastDateContractOrLot.dateValue;
                        $scope.directCreateRFQH(event, true);
                    }
                    else {
                        $scope.directCreateRFQH(event, true);
                    }
                });
            }
            else if (response.data && response.data.saveAttachmentsEncrypted) {
                RFXSupplierService.saveItemCommentsEncrypted($scope.data.id).then(function () {
                    $scope.directCreateRFQHAfterSave();
                }, function () {
                    LoadingDialogService.stop();
                    self.requestInProgress = false;
                    restoreAllItemComments();
                });
            }
            else if (impactX.isDefined(response, "data.tokens")) {
                RFXSupplierService.saveItemComments(response.data.tokens).then(function () {
                    $scope.directCreateRFQHAfterSave();
                }, function () {
                    LoadingDialogService.stop();
                    self.requestInProgress = false;
                    restoreAllItemComments();
                });
            }
        }, function () {
            LoadingDialogService.stop();
            self.requestInProgress = false;
            restoreAllItemComments();
        });
    };

    function reply(dataObj) {
        dataGen.postAsForm({}, dataObj, "/rfx/supplier/reply", null, false, true).then(function (response) {
            if (response && response.warnings && response.warnings.length > 0) {
                self.suppressWarnings = true;
            }
            else {
                if ($scope.locationWatcher) {
                    $scope.locationWatcher();
                }
                if ($scope.data.comparisonOffer) {
                    $redirect.redirectTo(null, "/rfxbuyer/" + $routeParams.rfqhId);
                } else if ($securityManager.isProcessAllowed("RFXSupplierView")) {
                    $redirect.redirectTo(null, "/rfxsupplierlist");
                } else if ($securityManager.isProcessAllowed("RFXSupplierViewForBuyer")) {
                    $redirect.redirectTo(null, "/rfx/offers/" + $routeParams.rfqhId);
                }
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            }
        }, function (rejectedData) {
            // refresh on failed validation since the items were versioned on save before trying to reply
            var reload = function () {
                getData();
                adjustSelections();
            };
            var errors = rejectedData && rejectedData.errors;
            if (errors && errors.length > 0) {
                $errorHandler.showErrors(errors, null, reload);
            } else {
                reload();
            }
        }).finally(function () {
            LoadingDialogService.stop();
            self.requestInProgress = false;
        });
    }

    function adjustSelections() {
        $scope.selectedItems = [];
        $scope.selectedContracts = [];
        $scope.selectedConditions = [];
    }

    $scope.replyRequest = function (event, preventMinLastDateContractOrLotCheck) {
        self.requestInProgress = true;
        var dataObj = {
            data: $scope.data,
            suppressWarnings: self.suppressWarnings
        };
        var saveDataObj = {
            data: $scope.data,
            forReply: true,
            checkLastDate: !preventMinLastDateContractOrLotCheck
        };
        cacheAllItemComments();
        LoadingDialogService.start();
        dataGen.postAsForm({}, saveDataObj, "/rfx/supplier/save").then(function (response) {
            if (response.data && response.data.minLastDateContractOrLot) {
                LoadingDialogService.stop();
                self.requestInProgress = false;
                restoreAllItemComments();
                $mdDialog.show({
                    controller: 'RFXLastValidDateConfirm',
                    controllerAs: 'rfxLastValidDateConfirm',
                    templateUrl: 'modules/rfxsupplier/templates/rfx-last-valid-date-confirm-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    bindToController: true,
                    locals: {
                        abortLabel: TranslationService.get("abort"),
                        actionLabel: $scope.trns.send,
                        warningLabel: TranslationService.get("warning"),
                        changeDateAndActionLabel: $scope.trns.changeDateAndSend,
                        minLastDateContractOrLot: response.data.minLastDateContractOrLot,
                        minLastDateContractOrLotMessage: response.data.minLastDateContractOrLotMessage
                    }
                }).then(function (answer) {
                    if (answer.changeDate) {
                        $scope.data.validDate.dateValue = response.data.minLastDateContractOrLot.dateValue;
                        $scope.replyRequest(event, true);
                    }
                    else {
                        $scope.replyRequest(event, true);
                    }
                });
            }
            else if (response.data && response.data.saveAttachmentsEncrypted) {
                RFXSupplierService.saveItemCommentsEncrypted($scope.data.id).then(function () {
                    reply(dataObj);
                }, function () {
                    LoadingDialogService.stop();
                    self.requestInProgress = false;
                    restoreAllItemComments();
                });
            }
            else if (impactX.isDefined(response, "data.tokens")) {
                RFXSupplierService.saveItemComments(response.data.tokens).then(function () {
                    reply(dataObj);
                }, function () {
                    LoadingDialogService.stop();
                    self.requestInProgress = false;
                    restoreAllItemComments();
                });
            }
        }, function () {
            LoadingDialogService.stop();
            self.requestInProgress = false;
            restoreAllItemComments();
        });
    };

    self.warnAndRedirectToConversations = function (event, isSupport) {
        if ($scope.dialogData.$dirty) {
            if (canSaveRequest()) {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveAndRedirectToConversations,
                    isSupport ? self.redirectToNewSupport : self.redirectToConversations, event,
                    $scope.trns.changedDataQuestion, TranslationService.get("save"), TranslationService.get("abort"), $scope.trns.noSave,
                    false);
            }
            else {
                if (isSupport) {
                    self.redirectToNewSupport();
                }
                else {
                    self.redirectToConversations();
                }
            }
        }
        else {
            if (isSupport) {
                self.redirectToNewSupport();
            }
            else {
                self.redirectToConversations();
            }
        }
    };

    self.warnAndRedirectToNewConversation = function (event) {
        if ($scope.dialogData.$dirty) {
            if (canSaveRequest()) {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveAndRedirectToNewConversation,
                    self.redirectToNewConversation, event, $scope.trns.changedDataQuestion, TranslationService.get("save"),
                    TranslationService.get("abort"), $scope.trns.noSave, false);
            }
            else {
                self.redirectToNewConversation();
            }
        }
        else {
            self.redirectToNewConversation();
        }
    };

    var cacheAllItemComments = function () {
        angular.forEach($scope.data.contracts, function (contract) {
            RFXSupplierService.cacheItemListComments(contract.items);
        });
    };

    var restoreAllItemComments = function () {
        angular.forEach($scope.data.contracts, function (contract) {
            RFXSupplierService.restoreItemListComments(contract.items);
        });
    };

    self.saveAndRedirectToConversations = function (event, answer) {
        if (answer !== 'forward') {
            var dataObj = {
                data: $scope.data
            };
            LoadingDialogService.start();
            cacheAllItemComments();
            dataGen.postAsForm({}, dataObj, "/rfx/supplier/save").then(function (response) {
                if (response.data.saveAttachmentsEncrypted) {
                    RFXSupplierService.saveItemCommentsEncrypted($scope.data.id)
                }
                else if (impactX.isDefined(response, "data.tokens")) {
                    RFXSupplierService.saveItemComments(response.data.tokens);
                }
                LoadingDialogService.stop();
                $redirect.redirectTo(null, 'rfxthread/supplier/' + $scope.data.headerId + "/" + $scope.data.supplierId);
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            }, function () {
                LoadingDialogService.stop();
                restoreAllItemComments();
            });
        }
        else {
            $redirect.redirectTo(null, 'rfxthread/supplier/' + $scope.data.headerId + "/" + $scope.data.supplierId);
        }
    };

    self.saveAndRedirectToNewConversation = function (event, answer) {
        if (answer !== 'forward') {
            var dataObj = {
                data: $scope.data
            };
            LoadingDialogService.start();
            cacheAllItemComments();
            dataGen.postAsForm({}, dataObj, "/rfx/supplier/save").then(function (response) {
                if (response.data.saveAttachmentsEncrypted) {
                    RFXSupplierService.saveItemCommentsEncrypted($scope.data.id)
                }
                else if (impactX.isDefined(response, "data.tokens")) {
                    RFXSupplierService.saveItemComments(response.data.tokens);
                }
                LoadingDialogService.stop();
                self.redirectToNewConversation();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            }, function () {
                LoadingDialogService.stop();
                restoreAllItemComments();
            });
        }
        else {
            self.redirectToNewConversation();
        }
    };

    self.redirectToConversations = function() {
        $redirect.redirectTo(null, $securityManager.isProcessAllowed("RFXThreadSupplierList") ?
            ("/rfxthread/supplier/" + $scope.data.headerId + "/" + $scope.data.supplierId) : ("rfxthread/buyer/" + $routeParams.rfqhId));
    };

    self.redirectToNewSupport = function() {
        $redirect.redirectTo(null, $securityManager.isProcessAllowed("RFXThreadSupplierList") ?
            ("/rfxthread/edit/supplier/0/" + $scope.data.headerId + "/" + $scope.data.supplierId + "/true") : ("rfxthread/edit/buyer/0/" + $routeParams.rfqhId + "/true"));
    };

    self.redirectToNewConversation = function() {
        $redirect.redirectTo(null, $securityManager.isProcessAllowed("RFXThreadSupplierList") ?
            ("/rfxthread/edit/supplier/0/" + $scope.data.headerId + "/" + $scope.data.supplierId + "/false") : ("rfxthread/edit/buyer/0/" + $routeParams.rfqhId + "/false"));
    };

    self.editSelectedItem = function (ev) {
        self.editItem(ev, $scope.selectedItems[0]).then(function (data) {
            RFXSupplierService.restoreItemComments(data.data);
            setItemDataToSelected(data);
        });
    };

    self.editItem = function (ev, item, fromCustomerItem) {
        var copiedItem = JSON.parse(JSON.stringify(item));
        if (copiedItem.sfiId || copiedItem.smartForm) {
            return showSmartFormDialog(ev, copiedItem, $scope.data.id).then(function (data) {
                if (data && data.smartForm) {
                    var policy = RFXSupplierService.getSmartFormPolicy(data.smartForm.identifier, $scope.data.smartFormPolicies);
                    copiedItem = data;
                    if (!fromCustomerItem) {
                        item.smartFormAttributes = copiedItem.smartFormAttributes;
                    } else {
                        copiedItem.isInformation = false; // Make behaviour consistent with supplier own form
                    }
                    return RFXSupplierService.updateItem(copiedItem, $scope.data.id);
                }
            });
        }
        else if (!copiedItem.productId && copiedItem.addedBySupplier) {
            return RFXSupplierService.showEditFreeformDialog(ev, copiedItem, $scope.trns, $scope.data.id, $scope.data.showGross);
        }
        else {
            return showItemChangeDialog(ev, copiedItem);
        }
    };

    function showItemChangeDialog(ev, copiedItem) {
        var headerLabel = copiedItem.isInformation ? $scope.trns.informationItem : copiedItem.name.value;
        return $mdDialog.show({
            templateUrl: "modules/rfx/templates/changerfxitem.tmpl.html",
            controller: "RFXChangeItemCtrl",
            controllerAs: "rfxChangeItemCtrl",
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                headerLabel: headerLabel,
                item: copiedItem,
                rfqsId: $scope.data.id,
                trns: $scope.trns,
                allowEditProduct: $scope.data.allowEditProduct
            }
        });
    }

    function showSmartFormDialog(event, copiedItem, rfqsId) {
        return $mdDialog.show({
            controller: 'RFXSupplierSmartFormItemCtrl',
            controllerAs: 'rfxSmartFormCtrl',
            templateUrl: 'modules/rfx/templates/rfx-smart-form-item.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                smartFormTemplates: $scope.data.smartFormTemplates,
                item: copiedItem,
                rfqsId: rfqsId,
                trns: $scope.trns
            }
        });
    }

    self.getProductSelectionParams = function(data) {
        var params = {id: $routeParams.id};
        params.data = data ? data : $scope.data;
        params.trns = $scope.trns;
        params.path = $location.path();
        if ($routeParams.amountToAdd) {
            params.path = params.path.substring(0, params.path.lastIndexOf("/"));
        }
        if ($routeParams.cscIdForProductToAdd) {
            params.path = params.path.substring(0, params.path.lastIndexOf("/"));
        }
        if ($routeParams.productIdToAdd) {
            params.path = params.path.substring(0, params.path.lastIndexOf("/"));
        }
        return params;
    };

    self.openProductSelection = function () {
        self.requestInProgress = true;
        cacheAllItemComments();
        LoadingDialogService.start();
        return dataGen.postAsForm({}, {data: $scope.data}, "/rfx/supplier/save").then(function (response) {
            if (response.data && response.data.saveAttachmentsEncrypted) {
                RFXSupplierService.saveItemCommentsEncrypted($scope.data.id).then(function () {
                    dataGen.getData({}, {id: $routeParams.id}, "/rfx/supplier/view").then(function (data) {
                        if ($scope.locationWatcher) {
                            $scope.locationWatcher();
                        }
                        LoadingDialogService.stop();
                        self.requestInProgress = false;
                        RFQSearchService.activateRFQSSearch(self.getProductSelectionParams(data.data));
                    },function (){
                        LoadingDialogService.stop();
                        self.requestInProgress = false;
                        restoreAllItemComments();
                    });
                }, function () {
                    LoadingDialogService.stop();
                    self.requestInProgress = false;
                    restoreAllItemComments();
                });
            }
            else if (impactX.isDefined(response, "data.tokens")) {
                RFXSupplierService.saveItemComments(response.data.tokens).then(function () {
                    dataGen.getData({}, {id: $routeParams.id}, "/rfx/supplier/view").then(function (data) {
                        if ($scope.locationWatcher) {
                            $scope.locationWatcher();
                        }
                        LoadingDialogService.stop();
                        self.requestInProgress = false;
                        RFQSearchService.activateRFQSSearch(self.getProductSelectionParams(data.data));
                    },function (){
                        LoadingDialogService.stop();
                        self.requestInProgress = false;
                        restoreAllItemComments();
                    });
                }, function () {
                    LoadingDialogService.stop();
                    self.requestInProgress = false;
                    restoreAllItemComments();
                });
            }
        }, function () {
            LoadingDialogService.stop();
            self.requestInProgress = false;
            restoreAllItemComments();
        });
    };

    self.canAddFreeFormItem = function () {
        return impactX.isDefined($scope, 'data.allowAddFreeformSupplier');
    };

    self.canAddSmartform = function () {
        return impactX.isDefined($scope, 'data.allowAddSmartFormSupplier');
    };

    self.canAddProduct = function () {
        return impactX.isDefined($scope, 'data.allowAddProductSupplier');
    };

    self.canAddCondition = function () {
        return impactX.isDefined($scope, 'data.allowAddConditionSupplier'); //currently not in use
    };

    // use negative identifiers for new basket item groups (to be able to distinguish them)
    var newBasketGroupIdentifier = -1;
    self.addFreeformItem = function ($event) {
        // get a new item from backend
        if (AppConfiguration.get('useFFClassicDialog')) {
            dataGen.getData({}, {
                rfqsId: $scope.data.id,
                proId: 0
            }, "/rfx/supplier/newsupplieritem").then(function (data) {
                if (data && data.data) {
                    // show the edit dialog
                    RFXSupplierService.showEditFreeformDialog($event, data.data, $scope.trns, $scope.data.id, $scope.data.showGross).then(function (data) {
                        if (data && data.data) {
                            data.data.isEdited = true;
                            RFXSupplierService.restoreItemComments(data.data);
                            RFXSupplierService.addItemToContracts(data.data, null, null, $scope.data, false, $scope.dialogData, sendErrorList);
                        }
                    });
                }
            });
        }
        else if (AppConfiguration.get('useFFOfferDialog')) {
            RFXSupplierService.showFreeformOfferDialog($event, 0, $scope.data.id, $scope.data.supplierId,
                undefined, undefined, undefined, undefined, undefined, $scope.data.contracts).then(function (data, completeOffer) {
                if (data && data.requestItem && data.completeOffer) {
                    // complete offer
                    RFXSupplierService.updateItem(data.requestItem, $scope.data.id).then(function (updatedData) {
                        if (updatedData && updatedData.data) {
                            data.requestItem = updatedData.data;
                            RFXSupplierService.restoreItemComments(data.requestItem);
                            RFXSupplierService.addItemToContracts(data.requestItem, data.contract, data.lot,
                                $scope.data, false, $scope.dialogData, sendErrorList, data.outlet);
                        }
                    });
                }
                else if (data && data.requestItems) {
                    // items offer
                    angular.forEach(data.requestItems, function (item) {
                        item.basketItemGroupId = newBasketGroupIdentifier;
                    });
                    newBasketGroupIdentifier--;
                    RFXSupplierService.updateItemList(data.requestItems, $scope.data.id).then(function (updatedData) {
                        if (impactX.isDefined(updatedData, 'data.itemList') && updatedData.data.itemList.length > 0) {
                            data.requestItems = updatedData.data.itemList;
                            RFXSupplierService.restoreItemListComments(data.requestItems);
                            addItemGroupToContracts(data);
                        }
                    });
                }
            });
        }
    };


    self.addSmartFormItem = function ($event) {
        dataGen.getData({}, {rfqsId: $scope.data.id, proId: 0}, "/rfx/supplier/newsupplieritem").then(function (item) {
            if (item && item.data) {
                delete item.data.csc;
                showSmartFormDialog($event, item.data, $scope.data.id).then(function (data) {
                    if (data && data.smartForm) {
                        var policy = RFXSupplierService.getSmartFormPolicy(data.smartForm.identifier, $scope.data.smartFormPolicies);
                        item.data = data;
                        delete item.data.selectedSmartFormTemplate;
                        RFXSupplierService.updateItem(item.data, $scope.data.id).then(function (response) {
                            RFXSupplierService.restoreItemComments(response.data)
                            if (policy && (!policy.isInformation && !policy.priceOnOrder)) {
                                RFXSupplierService.addItemToContracts(response.data, null, null, $scope.data, false, $scope.dialogData, sendErrorList);
                            }
                            else {
                                RFXSupplierService.addItemToContracts(response.data, null, null, $scope.data, false, $scope.dialogData, sendErrorList);
                            }
                        });
                    }
                });
            }
        });
    };

    self.addItemFromCustomer = function ($event, customerItem) {
        self.editItem($event, customerItem, true).then(function (data) {
            if (data && data.data) {
                RFXSupplierService.addItemToContracts(data.data, null, null, $scope.data, false, $scope.dialogData, sendErrorList);
                customerItem.isEdited = true;
                $scope.data.supplierToCustomerItem[data.data.id] = customerItem.id;
            }
        });
    }

    self.deletePositions = function (event, items) {
        if (!items) {
            items = $scope.selectedItems;
        }
        angular.forEach($scope.data.contracts, function (contract) {
            var basketItemGroups = {};
            angular.forEach(items, function (entry) {
                var index = contract.items.indexOf(entry);
                if (index >= 0) {
                    contract.items.splice(index, 1);
                    self.deleteItem(entry);
                }
                // if it was the item with the group data on it, cache that
                if (entry.basketItemGroupData && !basketItemGroups.hasOwnProperty(entry.basketItemGroupId)) {
                    basketItemGroups[entry.basketItemGroupId] = entry.basketItemGroupData;
                }
            });
            // copy the group data to the next item of the same group
            for (var key in basketItemGroups) {
                var otherGroupItems = findBasketItemGroupItems(contract, Number(key));
                if (otherGroupItems && otherGroupItems.length > 0) {
                    otherGroupItems[0].basketItemGroupData = basketItemGroups[key];
                }
            }

            if (contract.items.length === 0) {
                self.deleteContracts(event, [contract]);
            }
            else {
                RFXSupplierService.updateContract(contract, null, null, $scope.data, false, $scope.dialogData, sendErrorList);
            }
        });
        $scope.selectedItems.length = 0;
    };

    self.deleteItem = function (item) {
        var customerItem = findCustomerItem($scope.data.supplierToCustomerItem[item.id]);
        if (customerItem) {
            customerItem.isEdited = false;
            delete $scope.data.supplierToCustomerItem[item.id];
        }
        RFXSupplierService.updateSupplierHeaderSum(false, $scope.data, $scope.dialogData, sendErrorList);
    }

    function findConditionHolder(condition) {
        var lenC = $scope.data.contracts.length;
        for (var i=0; i<lenC; i++) {
            var contract = $scope.data.contracts[i];
            if (contract.conditions) {
                var indexC = contract.conditions.indexOf(condition);
                if (indexC >= 0) {
                    return contract;
                }
            }
            var lenI = contract.items.length;
            for (var j=0; j<lenI; j++) {
                var item = contract.items[j];
                if (item.conditions) {
                    var indexI = item.conditions.indexOf(condition);
                    if (indexI >= 0) {
                        return item;
                    }
                }
            }
        }
    }

    self.editConditionItem = function (event) {
        var condition = $scope.selectedConditions[0];
        var conditionHolder = findConditionHolder(condition);
        let cscId = 0;
        for (var i= 0; i < $scope.data.contracts.length; i++) {
            let contract = $scope.data.contracts[i];
            if (contract.conditions) {
                let conditionIndex = contract.conditions.indexOf(condition);
                if (conditionIndex >= 0) {
                    cscId = contract.id;
                    break;
                }
            }
            for (var j= 0; j < contract.items.length; j++) {
                let item = contract.items[j];
                if (item.conditions) {
                    let itemIndex= item.conditions.indexOf(condition);
                    if (itemIndex >= 0) {
                        cscId = contract.id;
                        break;
                    }
                }
            }
            if (cscId > 0) {
                break;
            }
        }
        if (conditionHolder) {
            var itemTax = impactX.isDefined(conditionHolder, "price.taxRate.selected.id");
            RFXSupplierService.showConditionDialogData(event, condition, $scope.trns, itemTax, cscId).then(function () {
                calcCondition(conditionHolder, condition, !conditionHolder.rfqsId);
            });
        }
    }

    self.addConditionItem = function (event) {
        var selectedItem = $scope.selectedItems[0];
        var conditionHolder = selectedItem ? selectedItem : $scope.selectedContracts[0];
        var contract = selectedItem ? RFXSupplierService.findContract(selectedItem, null, null, $scope.data) : $scope.selectedContracts[0];

        if (contract) {
            dataGen.getData({}, {rfqsId: $scope.data.id, isHeaderCondition: !!selectedItem, cscId: contract.id}, "/rfx/supplier/newconditionitem").then(function (data) {
                if (data && data.data) {
                    var itemTax = impactX.isDefined(selectedItem, "price.taxRate.selected.id");
                    RFXSupplierService.showConditionDialogData(event, data.data, data.trns, itemTax, contract.id).then(function (result) {
                        calcCondition(conditionHolder, result.item, !!selectedItem);
                        if (!conditionHolder.conditions) {
                            conditionHolder.conditions = [];
                        }
                        conditionHolder.conditions.push(result.item);
                    });
                }
            });
        }
    }

    function calcCondition (conditionHolder, condition, isItemCondition) {
        // eg: 16.00 % is represented as 1600 so the multiplier is 1+1/10000
        var taxRate = 1 + (condition.price.taxRate.selected.id / 10000);
        var value = Number(condition.price.netValue.value);
        if (condition.isRelative.setId == 1) {
            var valueRate = Number(condition.valueRate.value) / 100;
            var applyTo = 0;
            if (isItemCondition) {
                applyTo = conditionHolder.price.totalNetValue;
            }
            else {
                for (var i=0; i<conditionHolder.items.length; i++) {
                    var item = conditionHolder.items[i];
                    applyTo += item.price.totalNetValue;
                }
            }
            value = valueRate * applyTo;
        }
        // ui only shows positive value in input-field
        if (condition.conditionType.selected.id == 0) {
            value = -value;
        }
        condition.price.netValue.value = value;
        condition.price.totalNetValue = value;
        condition.price.grossValue = value * taxRate;
        condition.price.totalGrossValue = value * taxRate;

        // set formatted to '?' to imply that a recalc is needed
        condition.price.totalGrossValueFormatted = '?';
        condition.price.totalNetValueFormatted = '?';
        self.markAsChangedFunc();
    }

    self.deleteConditions = function (event) {
        var len = $scope.selectedConditions.length;
        for (var k=0; k<len; k++) {
            var condition = $scope.selectedConditions[k];
            var index;
            var holder;
            var lenC = $scope.data.contracts.length;
            for (var i=0; i<lenC; i++) {
                var contract = $scope.data.contracts[i];
                if (contract.conditions) {
                    var indexC = contract.conditions.indexOf(condition);
                    if (indexC >= 0) {
                        holder = contract
                        index = indexC;
                        break; // condition found, break contract loop
                    }
                }
                var lenI = contract.items.length;
                for (var j=0; j<lenI; j++) {
                    var item = contract.items[j];
                    if (item.conditions) {
                        var indexI = item.conditions.indexOf(condition);
                        if (indexI >= 0) {
                            holder = item
                            index = indexI;
                            break; // condition found, break item loop
                        }
                    }
                }
                if (index >= 0 && holder) {
                    break; // condition found, break contract loop
                }
            }
            if (index >= 0 && holder) {
                holder.conditions.splice(index, 1);
            }
        }
        $scope.selectedConditions = []; // reset selection
    }

    function findCustomerItem(id) {
        if (id) {
            var filtered = $scope.data.customerItems.filter(function (entry) {
                return entry.id === id;
            });
            if (filtered && filtered.length > 0) {
                return filtered[0];
            }
        }
    }

    function addItemGroupToContracts(itemGroup) {
        var foundContract = undefined;
        var selectedCscId = impactX.isDefined(itemGroup, 'contract.selected.id');
        var selectedLotId = impactX.isDefined(itemGroup, 'lot.selected.id')
        var outletId = impactX.isDefined(itemGroup, 'outlet.selected.id');
        angular.forEach($scope.data.contracts, function (contract) {
            if (selectedCscId === contract.id || selectedLotId === contract.lotId) {
                foundContract = contract;
            }
        });
        if (foundContract) {
            foundContract.items = foundContract.items.concat(itemGroup.requestItems);
        }
        else if (!selectedCscId && !selectedLotId) {
            foundContract = {
                cscId: 0,
                lotId: 0,
                items: itemGroup.requestItems
            }
        }
        else {
            foundContract = {
                cscId: selectedCscId,
                lotId: selectedLotId,
                items: itemGroup.requestItems
            };
        }
        if (foundContract && outletId) {
            foundContract.outletId = outletId ? outletId : 0
        }
        RFXSupplierService.updateContract(foundContract, null, null, $scope.data, false, $scope.dialogData, sendErrorList);
    }

    function setItemDataToSelected(data) {
        if (data && data.data) {
            $scope.selectedItems[0].price = data.data.price;
            $scope.selectedItems[0].unit = data.data.unit;
            $scope.selectedItems[0].amount = data.data.amount;
            $scope.selectedItems[0].cUnitsPerOUnit = data.data.cUnitsPerOUnit;
            $scope.selectedItems[0].contentUnit = data.data.contentUnit;
            if (data.data.description) {
                $scope.selectedItems[0].description.value = data.data.description.value;
            }
            if (data.data.name) {
                $scope.selectedItems[0].name = data.data.name;
            }
            if (data.data.supplierNo) {
                $scope.selectedItems[0].supplierNo = data.data.supplierNo;
            }
            $scope.selectedItems[0].selected = false;
            $scope.selectedItems[0].isEdited = true;
            $scope.selectedItems[0].smartForm = data.data.smartForm;
            $scope.selectedItems[0].comments = data.data.comments;
            $scope.selectedItems[0].eClassSelection = data.data.eClassSelection;
            $scope.selectedItems[0].naBeSelection = data.data.naBeSelection;

            var changeContract = false;
            var cscId = impactX.isDefined(data, 'data.csc.id');
            var lotId = impactX.isDefined(data, 'data.lot.id');
            if (cscId) {
                changeContract = $scope.selectedItems[0].csc && $scope.selectedItems[0].csc.id !== cscId;
            }
            else if (lotId) {
                changeContract = $scope.selectedItems[0].lot && $scope.selectedItems[0].lot.id !== lotId;
            }
            $scope.selectedItems[0].csc = data.data.csc;
            $scope.selectedItems[0].lot = data.data.lot;

            RFXSupplierService.updateContract(RFXSupplierService.findContract($scope.selectedItems[0], null, null, $scope.data), $scope.selectedItems[0], changeContract,
                $scope.data, false, $scope.dialogData, sendErrorList);

            if (changeContract) {
                self.deletePositions([$scope.selectedItems[0]])
            }
            $scope.selectedItems.length = 0;
        }
    }

    self.downloadAttachment = function (media) {
        DownloadService.openDownloadPost('/rfx/download/media', {paramName: "id", paramValue: media.id});
    };

    var canSaveRequest = function () {
        return $scope.data.canSave;
    };

    var canReworkRequest = function () {
        return $scope.data.canRework;
    };

    var canReplyRequest = function () {
        return $scope.data.canReply;
    };

    var canShare = function () {
        return $scope.data.canShare;
    };

    var allowConversations = function () {
        return $scope.data.allowConversations && ($securityManager.isProcessAllowed("RFXThreadSupplierList") || $securityManager.isProcessAllowed("RFXThreadBuyerList"));
    };

    var canChangeValidatyDate = function () {
        return $scope.data.canChangeValidityDate;
    };


    function canAddPosition() {
        return $scope.data.canEdit && $scope.selectedItems.length === 0 && $scope.selectedContracts.length === 0 && $scope.selectedConditions.length === 0;
    }

    function canEditPosition() {
        return $scope.data.canEdit && $scope.selectedItems.length === 1 && $scope.selectedContracts.length === 0 && $scope.selectedConditions.length === 0;
    }

    function canDeletePositions() {
        return $scope.data.canEdit && $scope.selectedItems.length >= 1 && $scope.selectedContracts.length === 0 && $scope.selectedConditions.length === 0 &&
            !$scope.selectedItems.filter(function (item) {
                return item.basketItemGroupId
            }).length;
    }

    function canDeleteContract() {
        return $scope.data.canEdit && $scope.selectedItems.length === 0 && $scope.selectedContracts.length >= 1 && $scope.selectedConditions.length === 0;
    }

    function canAddFreeformPosition() {
        return canAddPosition() && self.canAddFreeFormItem();
    }

    function canAddSmartformPosition() {
        return canAddPosition() && self.canAddSmartform();
    }

    function canAddProductPosition() {
        return canAddPosition() && self.canAddProductAndHasContracts();
    }

    self.disableAddProduct = function () {
        return !$scope.data.supplierId && !impactX.isDefined($scope, 'data.supplier.selected.id');
    }

    self.canAddProductAndHasContracts = function() {
        return self.canAddProduct() && !$scope.data.noContracts;
    };

    self.canEdit = function() {
        return $scope.data.canEdit;
    };

    function canAddConditionPosition() {
        return $scope.data.canEdit && self.canAddCondition() && ($scope.selectedItems.length === 1 || $scope.selectedContracts.length === 1);
    }

    function canEditConditionPositon() {
        return $scope.data.canEdit && self.canAddCondition() && ($scope.selectedConditions.length === 1);
    }

    function canDeleteCondition() {
        return $scope.data.canEdit && $scope.selectedItems.length === 0 && $scope.selectedContracts.length === 0 && $scope.selectedConditions.length > 0;
    }

    function findBasketItemGroupItems(contract, identifier) {
        return contract.items.filter(function (item) {
            return item.basketItemGroupId === identifier;
        });
    }



    self.deleteContracts = function (event, contracts) {
        if (!contracts) {
            contracts = $scope.selectedContracts;
        }
        angular.forEach(contracts, function (contract) {
            for (var i = 0; i < $scope.data.contracts.length; i++) {
                if (contract.id == $scope.data.contracts[i].id) {
                    $scope.data.contracts.splice(i, 1);
                }
            }
        });
        RFXSupplierService.checkErrors(sendErrorList, $scope.data);

    };

    self.isInformation = function (item) {
        var policy;
        if (item.smartForm) {
            policy = RFXSupplierService.getSmartFormPolicy(item.smartForm.identifier, $scope.data.smartFormPolicies);
        }
        return item.isInformation || (policy && policy.isInformation);
    }

    $scope.setButtons = function () {
        $scope.buttonDefinition = [
            {
                label: TranslationService.get("back"),
                action: $scope.back,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.saveRequest,
                action: $scope.save,
                type: 'dialogaction',
                condition: canSaveRequest,
            },
            {
                label: $scope.trns.saveRequestAndBack,
                action: $scope.saveAndBack,
                type: 'dialogaction',
                condition: canSaveRequest,
            },
            {
                label: $scope.trns.reworkRequest,
                action: $scope.reworkRequest,
                type: 'dialogaction',
                condition: canReworkRequest
            },
            {
                label: $scope.trns.replyRequest,
                action: $scope.replyDialog,
                type: 'validation',
                condition: canReplyRequest,
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: $scope.hasErrors, errorsFunction: $scope.getErrors}
                }
            },
            {
                label: $scope.trns.conversations,
                action: self.warnAndRedirectToConversations,
                type: 'dialogaction',
                condition: allowConversations
            },
            {
                label: $scope.trns.editItem,
                action: self.editSelectedItem,
                type: 'dialogaction',
                condition: canEditPosition
            },
            {
                label: $scope.trns.delete,
                action: self.deletePositions,
                type: 'dialogaction',
                condition: canDeletePositions
            },
            {
                label: $scope.trns.delete,
                action: self.deleteContracts,
                type: 'dialogaction',
                condition: canDeleteContract
            },
            {
                label: $scope.trns.addSmartFormPosition,
                action: self.addSmartFormItem,
                type: 'dialogaction',
                condition: canAddSmartformPosition
            },
            {
                label: $scope.trns.addCatalogPosition,
                action: self.openProductSelection,
                type: 'validation',
                condition: canAddProductPosition,
                params: {
                    form: $scope.supplierSelectedData,
                    disableExpression: {
                        valueFunction: self.disableAddProduct,
                        error: $scope.trns.needSupplier
                    }
                }
            },
            {
                label: $scope.trns.addFreeformPosition,
                action: self.addFreeformItem,
                type: 'dialogaction',
                condition: canAddFreeformPosition
            },
            {
                label: $scope.trns.addCondition,
                action: self.addConditionItem,
                type: 'dialogaction',
                condition: canAddConditionPosition
            },
            {
                label: $scope.trns.editCondition,
                action: self.editConditionItem,
                type: 'dialogaction',
                condition: canEditConditionPositon
            },
            {
                label: $scope.trns.delete,
                action: self.deleteConditions,
                type: 'dialogaction',
                condition: canDeleteCondition
            },
            {
                label: $scope.trns.share,
                action: self.shareRFX,
                type: 'dialogaction',
                condition: canShare
            },
            {
                label: $scope.trns.changeDate,
                action: self.changeDate,
                type: 'dialogaction',
                condition: canChangeValidatyDate,
            }
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons($scope.buttonDefinition);
    };

    $scope.adjustDates = function () {
        if ($scope.data.validFromDate) {
            $scope.data.validFromDate.minDate = new Date($scope.data.validFromDate.minDate);
            if ($scope.data.validDate) {
                $scope.data.validDate.minDate = new Date($scope.data.validDate.minDate);
                $scope.data.validDateMinDateValue = isNaN($scope.data.validDate.minDate) ||
                $scope.data.validDate.minDate < $scope.data.validFromDate.dateValue ? new Date($scope.data.validFromDate.dateValue) : $scope.data.validDate.minDate;
            }
        }
    };

    $scope.hasErrors = function () {
        return sendErrorList.list.length;
    }

    $scope.getErrors = function () {
        return sendErrorList.list;
    }

    $scope.hasCommentErrors = function () {
        return commentErrorList.list.length;
    }

    $scope.getCommentErrors = function () {
        return commentErrorList.list;
    }

    this.shareRFX = function (event) {
        return $mdDialog.show({
            controller: "RFXShareDialogCtrl",
            controllerAs: "rfxShareDialogCtrl",
            templateUrl: "modules/rfx/templates/rfxshare.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            escapeToClose: false,
            locals: {
                title: $scope.trns.share,
                hint: $scope.trns.shareHint,
                atLeastOneMailLabel: $scope.trns.atLeastOneMail,
                sendLabel: $scope.trns.send,
                rfqsId: $scope.data.id,
                offerCode: $scope.data.offerCode,
                copyToClipboardLabel: $scope.trns.copyToClipboard,
                copySuccessLabel: $scope.trns.copySuccess,
                offerCodeHint: $scope.trns.offerCodeHint,
            },
            bindToController: true
        });
    };


    this.changeDate = function (event) {
        $mdDialog.show({
            controller: "RFXSupplierEditValidityDateCtrl",
            controllerAs: "rfxSupplierEditValidityDateCtrl",
            templateUrl: "modules/rfx/templates/rfx-edit-validitydate.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                title: $scope.trns.changeDate,
                trns: $scope.trns,
                date: $scope.data.validDate,
                rfqsid: $scope.data.id
            },
            bindToController: true
        }).then(function (answer) {
            if (answer) {
                self.changeDateFinal(event, answer)
            }
        })
    };

    this.changeDateFinal = function (event, date, preventMinLastDateContractOrLotCheck) {
        dataGen.postAsForm({}, {id: $scope.data.id, validityDate: date, checkLastDate: !preventMinLastDateContractOrLotCheck,
            data: $scope.data}, "/rfx/supplier/editvaliditydate").then(function (response) {
            if (response.data && response.data.minLastDateContractOrLot) {
                $mdDialog.show({
                    controller: 'RFXLastValidDateConfirm',
                    controllerAs: 'rfxLastValidDateConfirm',
                    templateUrl: 'modules/rfxsupplier/templates/rfx-last-valid-date-confirm-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    bindToController: true,
                    locals: {
                        abortLabel: TranslationService.get("abort"),
                        actionLabel: $scope.trns.extend,
                        warningLabel: TranslationService.get("warning"),
                        changeDateAndActionLabel: $scope.trns.changeDateAndExtend,
                        minLastDateContractOrLot: response.data.minLastDateContractOrLot,
                        minLastDateContractOrLotMessage: response.data.minLastDateContractOrLotMessage
                    }
                }).then(function (answer) {
                    if (answer.changeDate) {
                        self.changeDateFinal(event, response.data.minLastDateContractOrLot, true);
                    }
                    else {
                        self.changeDateFinal(event, date, true);
                    }
                });
            }
            else {
                var oldReadOnly = $scope.data.validDate.readOnly;
                $scope.data.validDate.dateValue = date.dateValue;
                $scope.data.validDate.readOnly = oldReadOnly;
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            }
        });
    }

    this.changeSupplier = function ()
    {
        saveRequest(false);
    }

    self.markAsChangedFunc = function () {
        $scope.hasChanged = true;
    }

    const mainView = angular.element("#main-content");
    mainView.bind("scroll", function () {
        $scope.placeRefreshButton();
    });

    $scope.placeRefreshButton = function () {
        if ($scope.hasChanged) {
            const summaryElement = angular.element('#basket-summary');
            const stickyButtonElement = angular.element('#stickyRefreshButton');

            var middle = (summaryElement.offset().top + summaryElement.height());
            if (middle < (mainView.offset().top + mainView.height())) {
                stickyButtonElement.css({
                    "position": "absolute",
                    "bottom": "",
                    "right": "24px",
                    "top": "30%"
                });
            }
            else {
                stickyButtonElement.css({
                    "position": "fixed",
                    "bottom": "32px",
                    "right": "48px",
                    "top": ""
                });
            }
        }
    };

    getData();
}
